import React, { useState, useEffect } from 'react';
import Switch from "react-switch";
import { generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature } from "../../utils/helper";
import base64 from "base-64";
import RequestManager from "../../singletons/RequestManager";
import LoadingOverlay from "react-loading-overlay";

function Menu() {
  const [csvData, setCsvData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [filterText, setFilterText] = useState('');
  const [storeInformation, setStoreInformation] = useState('');
  const [spinnerLoading, setSpinnerLoading] = useState(false);

  const fetchJsonData = async () => {
    try {
      const vtimestamp = generateEpochTimestamp();
      const storeInformation = JSON.parse(localStorage.getItem('storeInformation'));
      const authToken = storeInformation.token;

      const response = await fetch('https://app.grabbngo.com/product/get_store_menu_with_store_code/', {
        method: 'POST',
        headers: {
          Authorization: `Token ${authToken}`,
          'Content-Type': 'application/json',
          Timestamp: vtimestamp,
          Signature: generateSignature(vtimestamp, authToken),
        },
        body: JSON.stringify({
          store_id: storeInformation.store.id,
          graphql: true,
        }),
      });

      if (response.status === 200) {
        const data = await response.json();
        const { result } = data;

        const newCsvData = result.map((item) => {
          const product = item.node;
          return {
            store_code: product.store_code || '',
            category: product.category || '',
            skucode: product.skucode || '',
            // name: `${product.name || ''}${product.description ? ' - ' + product.description : ''}`.trim(),
            name: product.name || '',
            price: product.saleprice || '',
            in_stock: product.in_stock || false,
            id: base64.encode('Stock:' + product.id),
          };
        });

        setCsvData(newCsvData);
      } else {
        console.log('Error fetching menu:', response.status);
      }
    } catch (error) {
      setErrorMessage('Error fetching JSON data: ' + error.message);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedData = [...csvData];
    updatedData[index][field] = value;
    setCsvData(updatedData);
  };

  const handleSwitchChange = async (index, checked, productId) => {
    const updatedData = [...csvData];
    setSpinnerLoading(true);
    let requestManager = new RequestManager();
    let params = { input: {} };
    if (checked === true) {
      params.input.inStockIds = [productId];
      params.input.outStockIds = [];
    } else if (checked === false){
      params.input.outStockIds = [productId];
      params.input.inStockIds = [];
    }

    let response = await requestManager.getResponseFromPredefinedQuery("updateStock", params);
    if (response.error === null) {
      const updatedData = csvData.map((item) =>
        item.id === productId ? { ...item, in_stock: checked } : item
      );
      setCsvData(updatedData);
      setSpinnerLoading(false);
    } else {
      setSpinnerLoading(false);
      alert("Unable to update inventory. Please check your internet connection.");
    }
  };

  const handleFilterChange = (event) => {
    setFilterText(event.target.value.toLowerCase());
  };

  const filteredData = csvData.filter(
    (row) =>
      row.skucode.toLowerCase().includes(filterText) ||
      row.category.toLowerCase().includes(filterText) ||
      row.name.toLowerCase().includes(filterText)
  );

  useEffect(() => {
    fetchJsonData();
  }, []);

  return (
    <div>
      <h2>Inventory</h2>
      {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
      <div style={{ marginBottom: '10px' }}>
        <input
          type="text"
          placeholder="Search by SKU Code, Category, or Name"
          value={filterText}
          onChange={handleFilterChange}
          style={{
            padding: '8px',
            width: '100%',
            boxSizing: 'border-box',
            fontSize: '14px',
            border: '1px solid #ddd',
          }}
        />
      </div>

      {filteredData.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {filteredData.map((row, index) => (
          <div
            key={index}
            style={{
              border: '1px solid #ddd',
              padding: '20px',
              backgroundColor: '#f9f9f9',
              width: '100%', // Full width of the container for each card
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}
          >
            <h3 style={{ fontSize: '18px' }}>{row.name}</h3>
      
            {/* First Row for Headers (Category, SKU Code, Price, In Stock) */}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold' }}>
              <div style={{ flex: 1, paddingRight: '10px' }}>Category</div>
              <div style={{ flex: 1, paddingRight: '10px' }}>SKU Code</div>
              <div style={{ flex: 1, paddingRight: '10px' }}>Price</div>
              <div style={{ flex: 1 }}>In Stock</div>
            </div>
      
            {/* Second Row for Data (Category, SKU Code, Price, In Stock toggle button) */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ flex: 1, paddingRight: '10px' }}>{row.category}</div>
              <div style={{ flex: 1, paddingRight: '10px' }}>{row.skucode}</div>
              <div style={{ flex: 1, paddingRight: '10px' }}>{row.price}</div>
              <div style={{ flex: 1,}}>
                <Switch
                  checked={row.in_stock}
                  id={row.id}
                  onChange={(checked) => handleSwitchChange(index, checked, row.id)}
                  
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      
      
      
     
      ) : (
        <div>No results found.</div>
      )}
    </div>
  );
}

export default Menu;



// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/Menu.js